import { createSelector } from '@reduxjs/toolkit';
import { State } from '../../client/configureStore';

const getEpisodesViewSelector = (itemId: string) =>
  createSelector(
    (state: State) => state.episodesViews,
    episodes => {
      if (itemId) {
        return episodes[itemId];
      }
    }
  );

export const getSeasonTitlesSelector = (itemId: string) =>
  createSelector(getEpisodesViewSelector(itemId), view => {
    return view?.seasons.map(s => s.title) ?? [];
  });

const getSeasonsSelector = (itemId: string) =>
  createSelector(getEpisodesViewSelector(itemId), view => view?.seasons);

export const getEpisodesBySeasonsSelector = (itemId: string) =>
  createSelector(
    getSeasonsSelector(itemId),
    seasons =>
      seasons?.map(season => season.lists.flatMap(list => list.episodes)) ?? []
  );

export const getViewTitleSelector = (itemId: string) =>
  createSelector(getEpisodesViewSelector(itemId), view => view?.title ?? '');

const getSelectSeason = (seasonIndex: number, itemId: string) =>
  createSelector(getSeasonsSelector(itemId), seasons => seasons?.[seasonIndex]);

export const getListSelector = (
  seasonIndex: number,
  listIndex: number,
  itemId: string
) =>
  createSelector(
    (state: State) => getSelectSeason(seasonIndex, itemId)(state),
    season => season?.lists[listIndex]
  );

export const getEpisodesSelector = (itemId: string) =>
  createSelector(
    getSeasonsSelector(itemId),
    seasons =>
      seasons?.flatMap(season => season.lists.flatMap(list => list.episodes)) ??
      []
  );

export const getCurrentEpisodesViewAnalyticsSelector = (itemId: string) =>
  createSelector(
    getEpisodesViewSelector(itemId),
    episodesView => episodesView?.analytics
  );

export const getIsCurrentViewInitializedSelector = (itemId: string) =>
  createSelector(getEpisodesViewSelector(itemId), episodesView =>
    Boolean(episodesView)
  );
